import React, { useState, useEffect, useCallback, useRef, useContext, forwardRef, useImperativeHandle } from "react";
import { useSelector } from 'react-redux';
import { Container, Row, Col, Button } from "react-bootstrap";
import Navigation from './Navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { useMutationObserver } from '../hooks/useMutationObserver';
import LangSelector from "./LangSelector";


const Screen = forwardRef((props, ref) => {


    const navigate = useNavigate();

    const { data: hotel, agent } = useContext(HotelContext)

    const contentRef = useRef()
    const [showScrollingHeader, setShowScrollingHeader] = useState(false);
    const [showNavigation, setShowNavigation] = useState(true)
    const [isShortPage, setIsShortPage] = useState(false);

    const handleScroll = useCallback(event => {
        setShowScrollingHeader(event.currentTarget.scrollTop > 40);
    }, []);

    const handleResize = () => {
        checkIsShortPage();
    }

    useEffect(() => {
        contentRef.current.scrollTop = 0;
    }, [props?.section]);

    useEffect(() => {
        if (!contentRef) return;
        const div = contentRef.current;
        div.addEventListener("scroll", handleScroll);
    }, [handleScroll]);

    const checkIsShortPage = () => {
        setIsShortPage(false);
        setIsShortPage(contentRef?.current?.scrollHeight <= contentRef?.current?.clientHeight)
    }

    useEffect(() => {
        checkIsShortPage();
    }, [contentRef?.current?.scrollHeight, contentRef?.current?.clientHeight]);

    useEffect(() => {
        checkIsShortPage();

        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        if (props.autoScrollToBottom && contentRef?.current) {
            // refItemsContainer.current?.scrollIntoView({ block: "end" });
            // refItemsContainer.current.scrollTop = 150
            contentRef.current.scrollTop = contentRef.current.scrollHeight;
            console.log('contentRef.current.scrollTop', contentRef.current.scrollTop);
            console.log('contentRef.current.scrollHeight', contentRef.current.scrollHeight);
        }
    }, [props?.autoScrollToBottom])

    useMutationObserver(contentRef, () => {
        let isShortWithFooter = true;
        const short = contentRef?.current?.scrollHeight <= contentRef?.current?.clientHeight;

        let _calculatedHeight = 0;
        const pageHeader = contentRef?.current?.querySelector('.page-header');
        if (pageHeader && pageHeader?.clientHeight) {
            _calculatedHeight += pageHeader.clientHeight;
        }

        const pageContent = contentRef?.current?.querySelector('.page-content-row');
        if (pageContent && pageContent?.clientHeight) {
            _calculatedHeight += pageContent.clientHeight;
        }
        const footer = contentRef?.current?.querySelector('.footer-container');
        if (footer && footer?.clientHeight) {
            _calculatedHeight += footer.clientHeight;
        }

        // if (short) {
        //     const footer = contentRef.current.querySelector('.footer-container');
        //     if (footer && footer?.clientHeight) {
        //         isShortWithFooter = (contentRef?.current?.scrollHeight + footer.clientHeight) <= contentRef?.current?.clientHeight;
        //         // checkIsShortPage(short && isShortWithFooter);
        //         console.log('0606 - useMutationObserver isShortWithFooter', isShortWithFooter)
        //     }
        // }

        if (_calculatedHeight > 0) {
            setIsShortPage(_calculatedHeight <= contentRef?.current?.clientHeight);
        }
    });

    useImperativeHandle(ref, () => ({
        scrollToTop() {
            if (contentRef) {
                // refContainer.current?.scrollIntoView({ block: "end" });
                console.log('contentRef.current.scrollTop', contentRef.current.scrollTop)
                contentRef.current.scrollTop = 0
                console.log('contentRef.current.scrollTop', contentRef.current.scrollTop)
                console.log('contentRef.current.scrollHeight', contentRef.current.scrollHeight)
                // refContainer.current.scrollTop = refContainer.current.scrollHeight;
            }
        },
        // forceCheckHeightPage() {
        //     // TODO::: hacerlo con evento sobre el cambio de height del div ... no con un forzado desde afuera
        //     setTimeout(() => {
        //         checkIsShortPage()
        //     }, 150);
        // }
    }));

    const BackButton = () => {
        return <Button
            className={`back-button d-flex justify-content-center align-items-center ${props.transparent ? 'back-button-transparent' : ''}`}
            onClick={() => {
                let backBreak = false;
                if (props.onBackClick) {
                    backBreak = props.onBackClick() || false;
                }
                if (!backBreak) {
                    if (props.backUrl) {
                        navigate(`/${hotel.code}/${props.backUrl}`, { replace: true })
                    } else {
                        if (window?.history?.state) {
                            if (window.history.state.usr?.from) {
                                navigate(-1)
                            } else {
                                navigate(`/${hotel.code}`, { replace: true })
                            }
                        } else {
                            navigate(`/${hotel.code}`, { replace: true })
                        }
                    }
                }
            }}>
            <FontAwesomeIcon className="back-button-icon" icon={agent?.os?.name === "iOS" ? faAngleLeft : faArrowLeft} />
        </Button>
    }

    const immersive = !!props.immersive;

    return (
        <Container
            className={`page-container ${props.section ? `page-${props.section}` : ''} ${showScrollingHeader ? 'scrolling-header-visible' : ''} ${!props.showBackButton && !props.title ? 'header-empty' : ''} ${props.headerTranslucid ? 'page-header-translucid' : ''} ${props.classes} ${showNavigation && !immersive ? 'with-navigation' : 'without-navigation'} ${isShortPage ? 'is-short-page' : ''} ${immersive ? 'page-immersive' : ''}`}
            ref={contentRef}
            style={
                immersive
                    ? {
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        minHeight: "100%",
                        maxWidth: "100%",
                        paddingLeft: 0,
                        paddingRight: 0,
                      }
                    : undefined
            }
        >

            {/* Fondo desenfocado */}
            {props.backGroundImage && !immersive && (
                <div className="back-ground-image-vico"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100vh',
                        backgroundImage: `url(${props.backGroundImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'repeat-y',
                        filter: 'blur(8px)',
                        zIndex: 1,
                    }}
                />
            )}
            {/* Contenido principal */}
            <div
                style={
                    immersive
                        ? {
                            position: 'relative',
                            zIndex: 1,
                            flex: 1,
                            minHeight: 0,
                            display: "flex",
                            flexDirection: "column",
                        }
                        : { position: 'relative', zIndex: 1 }
                }
            > {/* Aseguramos que el contenido esté por encima del fondo */}

                {!props.hideHeader && !immersive && (
                    <>
                        <div className={`page-scrolling-header`}>
                            <div className="page-scrolling-header-content">
                                <div className="flex items-center">
                                    {props.showBackButton && <BackButton />}
                                    <h1 style={{ overflowX: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginRight: 20, marginLeft: 60 }}>{props.title}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="page-header">
                            {props.showBackButton && <BackButton />}
                            <div className="page-header-text">
                                {props.title && <h1>{props.title}</h1>}
                                {props.description && <p dangerouslySetInnerHTML={{ __html: props.description }} />}
                            </div>
                            {props.headerContent}
                        </div>
                    </>
                )}

                {props.LangSelector && !immersive &&
                    <div className="mt-4 mb-0">
                        <LangSelector />
                    </div>}
                <Row
                    className={`page-content-row ${immersive ? 'g-0 m-0' : ''}`}
                    style={immersive ? { flex: 1, minHeight: 0 } : undefined}
                >
                    <Col
                        className={`page-content ${immersive ? 'p-0' : ''}`}
                        style={
                            immersive
                                ? {
                                    maxWidth: "100%",
                                    flex: "1 1 auto",
                                    minHeight: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                }
                                : undefined
                        }
                    >

                        {props.children}
                    </Col>
                </Row>

                {showNavigation && !immersive && <Navigation setShowNavigation={setShowNavigation} />}
            </div>
        </Container>
    );
});

Screen.defaultProps = {
    showBackButton: true,
    classes: '',
    backUrl: null
}

export default Screen;